<template>
    <div class="card">
        <div class="card-header">Reciprocity information</div>
        <div class="card-body">
            <b-row>
                <b-col>
                    <h2>Reciprocity information for applicants from outside Missouri, New Mexico, Oklahoma, or Oregon</h2>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    If you are seeking reciprocity you will need to contact your
                    state's licensing body and request that they send over an official verification of your credentials, and
                    if you are seeking reciprocity from outside the approved states listed above, a
                    copy of relevant state statutes, by mail or email, to the Minnesota Department of Health.
                    <p>By mail:<br/>
                        HEALTH OCCUPATIONS PROGRAM<br/>
                        Body Art Licensing<br/>
                        P.O. Box 64882<br/>
                        St. Paul, Minnesota 55164-0882<br/>
                        By email: <a href="mailto:health.ba@state.mn.us">health.ba@state.mn.us</a>
                    </p>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    A copy of these instructions will be emailed to you.
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Reciprocity"
    }
</script>

<style scoped>

</style>